<template>
  <v-btn
    v-if="layout && layout.showSettingsIcon"
    icon
    @click="() => changeSettingsDialogVisibility(true)"
  >
    <v-icon>mdi-settings</v-icon>
  </v-btn>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import navigateMixin from '../../mixins/navigate'

export default {
  computed: {
    ...mapGetters('common', {
      layout: 'layout'
    }),
  },
  methods: {
    ...mapMutations('common', ['changeSettingsDialogVisibility']),
  }
}
</script>
